import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'material-ui/styles';
import Close from 'material-ui-icons/Close';
import IconButton from 'material-ui/IconButton';
import Typography from 'material-ui/Typography';
import CheckCircle from '../../Icons/CheckCircle';
import Button from 'material-ui/Button';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

const styles = () => ({
  root: {
    background: "#040E35",
    position: 'absolute',
    top: 15,
    right: 15,
    width: '456px',
    '-webkit-box-shadow': '0px 5px 20px 0px rgba(0,0,0,0.38)',
    '-moz-box-shadow': '0px 5px 20px 0px rgba(0,0,0,0.38)',
    boxShadow: '0px 5px 20px 0px rgba(0,0,0,0.38)',
    padding: '20px',
    zIndex: 999,
  },

  iconButton: {
    position: 'absolute',
    right: 5,
    top: 5,
    color: 'white',
    width: 'unset',
    height: 'unset',
  },

  row: {
    display: 'flex',
    flexDirection: 'column',
    borderBottom: '1px solid #232941',
    alignItems: 'flex-start',
    textAlign: 'left',
    paddingBottom: '15px',
  },

  content: {
    margin: '15px 0px',
    display: 'flex',
  },

  left: {
    width: '251px',
    minWidth: '251px',
    marginRight: '20px',
  },

  right: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },

  inline: {
    display: 'inline-flex',
    alignItems: 'center',
  },

  footer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: '15px',
    width: '100%',
    justifyContent: 'flex-end',
  },

  button: {
    border: "1px solid #FFFFFF",
    color: '#FFFFFF',
    marginLeft: '20px',
    fontSize: '11px',
    height: '30px',
    minHeight: 'unset',
    padding: '6px 15px',
  },
});

class InfoBox extends React.Component {
  state = {
    checked: false,
  }

  handleCheck = () => {
    this.setState({ checked: !this.state.checked });
  }

  handleClose = () => {
    if (this.state.checked) {
      const intervalYear = 2;
      this.props.cookies.set('showInfoBox', 0, { path: '/', expires: new Date(new Date().setFullYear(new Date().getFullYear() + intervalYear)) });
    }

    this.props.toggleDialog();
  }

  renderWithCheckCircle = (text) => {
    const { classes } = this.props;

    return (
      <div className={classes.inline}>
        <CheckCircle color="#33F084" width={15} height={15} />
        <Typography variant="body1" style={{ color: '#FFFFFF', marginRight: '5px', lineHeight: '19px' }}> {text}</Typography>
      </div>
    )
  }

  render() {
    const { toggleDialog, classes } = this.props;

    return (
      <div className={classes.root}>
        <IconButton onClick={toggleDialog} className={classes.iconButton}>
          <Close color="inherit" style={{ width: '16px', height: '16px' }} />
        </IconButton>

        <div className={classes.row}>
          <Typography variant="body2" style={{ color: '#FFFFFF', fontWeight: 'bold' }}> キーマンデータベースとは？</Typography>

          <div className={classes.content}>
            <div className={classes.left}>
              <Typography variant="body1" style={{ color: '#FFFFFF', lineHeight: '19px' }}>
                集計期間内に発表されたキーマンの着任情報をもとにKeyman Letterが独自に取りまとめたターゲットリストです。新規顧客開拓にご活用いただけます。
              </Typography>
            </div>

            <div className={classes.right}>
              {this.renderWithCheckCircle('デイリーで情報更新')}
              {this.renderWithCheckCircle('システム+人力で品質管理')}
              {this.renderWithCheckCircle('豊富な絞り込み条件')}
            </div>
          </div>

          <Typography variant="body1" style={{ lineHeight: '17px' }}>※住所は登記上の本店住所です。</Typography>
          <Typography variant="body1" style={{ lineHeight: '17px' }}>※実際の着任日は該当期間内でない場合があります。</Typography>
          <Typography variant="body1" style={{ lineHeight: '17px' }}>※企業が退任情報を公開しなかった場合、在任扱いとして残っている可能性があります。検索条件の「退任リスクのキーマンを除外」をご利用ください。（完全に退任の除外を保証するものではありません）</Typography>
        </div>

        <div className={classes.footer}>
          <div className={classNames(classes.inline, 'clickable')} onClick={this.handleCheck}>
            <input
              type="checkbox"
              checked={this.state.checked}
              onChange={this.handleCheck} />

            <Typography variant="body1" style={{ color: "#FFFFFF" }}>
              次回から表示しない
            </Typography>
          </div>

          <Button onClick={this.handleClose} className={classes.button}>了解です</Button>
        </div>
      </div>
    );
  }
}

InfoBox.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool,
  toggleDialog: PropTypes.func.isRequired,
  cookies: instanceOf(Cookies).isRequired,
};

InfoBox.defaultProps = {
}


export default withCookies(withStyles(styles)(InfoBox));



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/InfoBox.jsx